export const ROUTE_PATHS = {
  HOME: '/',
};

export interface QuizQuestion {
  id: number;
  question: string;
  options: string[];
  correctIndex: number;
  explanation: string;
}

export interface TimelineEvent {
  year: string;
  title: string;
  description: string;
  icon: string;
}

export interface FunFact {
  id: number;
  emoji: string;
  title: string;
  content: string;
}

export const TIMELINE_EVENTS: TimelineEvent[] = [
  {
    year: "1920",
    title: "TBMM'nin Açılışı",
    description: "23 Nisan 1920'de Büyük Millet Meclisi, Ankara'da Mustafa Kemal Atatürk önderliğinde törenle açıldı. Bu, milletin kendi kaderini tayin etmeye başladığı tarihi gündü.",
    icon: "🏛️",
  },
  {
    year: "1921",
    title: "İlk Milli Bayram",
    description: "23 Nisan, Türkiye'nin ilk resmi milli bayramı olarak 'Hakimiyet-i Milliye Bayramı' adıyla kutlanmaya başlandı. Milletin egemenliğinin simgesi oldu.",
    icon: "🎉",
  },
  {
    year: "1927",
    title: "Çocuk Bayramı İlanı",
    description: "Himaye-i Etfal Cemiyeti (Çocuk Esirgeme Kurumu) tarafından bu tarih 'Çocuk Bayramı' olarak da ilan edildi. Atatürk bayramı Türkiye'nin çocuklarına armağan etti.",
    icon: "🎈",
  },
  {
    year: "1933",
    title: "Makam Devri Geleneği",
    description: "Atatürk, kendi koltuğunu çocuklara bırakarak 'Makam Devri' geleneğini başlattı. Bu gelenek, 'Gelecek sizin' mesajını simgeliyor.",
    icon: "👑",
  },
  {
    year: "1979",
    title: "Dünya Çocuklarına Armağan",
    description: "UNESCO'nun 'Dünya Çocuk Yılı' ilan etmesiyle TRT, bayramı uluslararası boyuta taşıdı. 5 ülkeden gelen çocuklar ilk kez kutlamalara katıldı.",
    icon: "🌍",
  },
  {
    year: "2026",
    title: "Bugün: 106. Yıl",
    description: "23 Nisan bugün 106. yılında! 110'dan fazla ülkeden çocuklar bu büyük günü birlikte kutluyor. Türkiye, dünyada çocuklara bayram armağan eden tek ülke!",
    icon: "🎊",
  },
];

export const QUIZ_QUESTIONS: QuizQuestion[] = [
  {
    id: 1,
    question: "TBMM (Türkiye Büyük Millet Meclisi) hangi yıl açıldı?",
    options: ["1918", "1919", "1920", "1921"],
    correctIndex: 2,
    explanation: "TBMM, 23 Nisan 1920'de Ankara'da Mustafa Kemal Atatürk öncülüğünde açıldı.",
  },
  {
    id: 2,
    question: "23 Nisan bayramı kaç yılında çocuklara armağan edildi?",
    options: ["1921", "1923", "1927", "1935"],
    correctIndex: 2,
    explanation: "1927 yılında Himaye-i Etfal Cemiyeti tarafından 'Çocuk Bayramı' olarak ilan edildi.",
  },
  {
    id: 3,
    question: "'Egemenlik kayıtsız şartsız milletindir' sözü kime aittir?",
    options: ["İsmet İnönü", "Mustafa Kemal Atatürk", "Fevzi Çakmak", "Kazım Karabekir"],
    correctIndex: 1,
    explanation: "Bu tarihi söz, Türkiye Cumhuriyeti'nin kurucusu Mustafa Kemal Atatürk'e aittir.",
  },
  {
    id: 4,
    question: "23 Nisan uluslararası kutlamalara kaç yılından itibaren başlandı?",
    options: ["1965", "1970", "1975", "1979"],
    correctIndex: 3,
    explanation: "1979'da UNESCO'nun 'Dünya Çocuk Yılı' ilan etmesiyle TRT uluslararası kutlamaları başlattı.",
  },
  {
    id: 5,
    question: "Kaç ülkeden fazla çocuk 23 Nisan'ı kutlamaktadır?",
    options: ["50", "75", "100", "110"],
    correctIndex: 3,
    explanation: "Günümüzde 110'dan fazla ülkeden çocuklar 23 Nisan'ı birlikte kutlamaktadır.",
  },
];

export const FUN_FACTS: FunFact[] = [
  {
    id: 1,
    emoji: "🌟",
    title: "Dünyada Bir İlk!",
    content: "Türkiye, dünyada çocuklara resmi olarak bir bayram armağan eden tek ülkedir. Bu benzersiz bir tarihi önem taşır!",
  },
  {
    id: 2,
    emoji: "🚗",
    title: "Atatürk'ün Arabası",
    content: "Atatürk, 1927 yılındaki kutlamalarda kendi makam arabasını çocuklara tahsis ederek bayram turuna çıktırdı.",
  },
  {
    id: 3,
    emoji: "🏰",
    title: "Çocuk Sarayı",
    content: "1927'de Ankara'da bir bina 'Çocuk Sarayı' olarak adlandırıldı ve çocukların kullanımına tahsis edildi.",
  },
  {
    id: 4,
    emoji: "🎭",
    title: "Makam Devri",
    content: "Her yıl TBMM'de çocuklara özel oturum yapılır. Çocuklar milletvekili koltuklarına oturarak oylama yapar!",
  },
  {
    id: 5,
    emoji: "🌍",
    title: "Kosova'da da Kutlanır!",
    content: "Kosova'da yaşayan Türkler, 23 Nisan'ı resmi tatil olarak kutlamaktadır. Bayramın etkisi sınırları aşmıştır!",
  },
  {
    id: 6,
    emoji: "📅",
    title: "Üç Bayramın Birleşimi",
    content: "23 Nisan aslında üç ayrı bayramın birleşimidir: Milli Bayram, Hakimiyet-i Milliye Bayramı ve Çocuk Bayramı.",
  },
];
